// src/features/clinical/context/ClinicalContext.jsx
import React, { createContext, useContext, useState, useCallback } from 'react';
import clinicalApi from '../services/clinicalApi';

const ClinicalContext = createContext(null);

export const useClinical = () => {
  const context = useContext(ClinicalContext);
  if (!context) {
    throw new Error('useClinical must be used within ClinicalProvider');
  }
  return context;
};

export const ClinicalProvider = ({ children }) => {
  const [currentPatient, setCurrentPatient] = useState(null);
  const [currentVisit, setCurrentVisit] = useState(null);
  const [currentPrescription, setCurrentPrescription] = useState(null);
  const [loading, setLoading] = useState(false);

  const selectPatient = useCallback(async (patientId) => {
    setLoading(true);
    try {
      const response = await clinicalApi.getPatient(patientId);
      setCurrentPatient(response.data);
    } catch (error) {
      console.error('Failed to load patient:', error);
    } finally {
      setLoading(false);
    }
  }, []);

  const startVisit = useCallback(async (patientId, visitData) => {
    setLoading(true);
    try {
      const data = {
        patientId,
        ...visitData,
        status: 'IN_PROGRESS'
      };
      const response = await clinicalApi.createVisit(data);
      setCurrentVisit(response.data);
      return response.data;
    } catch (error) {
      console.error('Failed to start visit:', error);
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  const value = {
    currentPatient,
    currentVisit,
    currentPrescription,
    loading,
    selectPatient,
    startVisit,
    setCurrentPrescription
  };

  return (
    <ClinicalContext.Provider value={value}>
      {children}
    </ClinicalContext.Provider>
  );
};